import { u2000ShiftCivilYmd } from '../../u2000Core/tools/U2000DateTimeHelpers';

/** Limite inclusive backend BL-0182 (jours civils). */
export const U3301_INTERVAL_MAX_DAYS = 90;

export type U3301IntervalValidationError = 'invalid' | 'order' | 'tooLong';

export type U3301IntervalValidationResult =
  | { ok: true; dayCount: number }
  | { ok: false; error: U3301IntervalValidationError };

/**
 * Valide une plage civile inclusive yyyy-MM-dd (fin ≥ début, ≤ 90 jours).
 * Arithmétique jour civil via U2000 — pas d’ISO UTC / toISOString.
 */
export function u3301ValidateInclusiveDateInterval(
  startDate: string,
  endDate: string,
  maxDays: number = U3301_INTERVAL_MAX_DAYS,
): U3301IntervalValidationResult {
  const start = startDate.trim();
  const end = endDate.trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(start) || !/^\d{4}-\d{2}-\d{2}$/.test(end)) {
    return { ok: false, error: 'invalid' };
  }
  if (end < start) {
    return { ok: false, error: 'order' };
  }

  let dayCount = 1;
  let cursor = start;
  while (cursor < end) {
    const next = u2000ShiftCivilYmd(cursor, 1);
    if (!next) return { ok: false, error: 'invalid' };
    cursor = next;
    dayCount += 1;
    if (dayCount > maxDays) {
      return { ok: false, error: 'tooLong' };
    }
  }

  return { ok: true, dayCount };
}
